module.exports = __webpack_public_path__ + "img/branching-space-times-cover.f7ee3174.jpg";